import en from "./en"
import nl from "./nl"

const i18nResources = {
    en,
    nl,
}

export default i18nResources
